/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TransactionState {
    PENDING = 'PENDING',
    INCOMPLETE = 'INCOMPLETE',
    COMPLETED = 'COMPLETED',
}
